import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react'; // 1. Import useAuth0

const SuccessPage = () => {
  // State to hold the filename and control UI visibility
  const [zipFilename, setZipFilename] = useState<string | null>(null);
  const [isDownloadReady, setIsDownloadReady] = useState(false);
  const { getAccessTokenSilently } = useAuth0(); // 2. Get the token function

  // This is the correct download handler function from before
  const handleDownload = async (filename: string) => {
    try {
       const baseUrl = process.env.REACT_APP_API_BASE_URL || '';
       console.error("baseUrl:", baseUrl);
       // 3. Get the authentication token before making the request
        const token = await getAccessTokenSilently();

       const response = await fetch(`${baseUrl}/api/download/${filename}`, {
         headers: {
          // 5. CRITICAL: Add the Authorization header
           Authorization: `Bearer ${token}`
         }
       });

       if (!response.ok) {
         throw new Error(`Server responded with ${response.status}`);
       }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      if (link.parentNode) {
        link.parentNode.removeChild(link);
      }
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
      alert("Sorry, the file could not be downloaded.");
    }
  };

  // This useEffect now prepares the download, but doesn't start it
  useEffect(() => {
    const filename = localStorage.getItem('zipFilename');
    const checkoutStatus = localStorage.getItem('checkoutStatus');

    // Check that a payment was just completed
    if (filename && checkoutStatus === 'pending') {
      setZipFilename(filename);
      setIsDownloadReady(true); // Set state to show the download button

      // Clear the items from localStorage to prevent re-downloads on page refresh
      localStorage.removeItem('zipFilename');
      localStorage.removeItem('checkoutStatus');
    }
  }, []); // The empty array [] ensures this runs only once

  // Custom styles for better presentation
  const styles = {
    container: {
      fontFamily: 'sans-serif',
      textAlign: 'center' as 'center',
      padding: '40px 20px',
      maxWidth: '600px',
      margin: '50px auto',
      border: '1px solid #ddd',
      borderRadius: '8px',
      boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    },
    header: {
      color: '#28a745', // A success green color
      fontSize: '2rem',
    },
    button: {
      display: 'inline-block',
      backgroundColor: '#007AFF',
      color: 'white',
      padding: '15px 30px',
      fontSize: '1.2rem',
      fontWeight: 'bold' as 'bold',
      textDecoration: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
      border: 'none',
      margin: '20px 0',
    },
    instructions: {
      marginTop: '20px',
      fontSize: '0.9rem',
      color: '#666',
      backgroundColor: '#f9f9f9',
      padding: '15px',
      borderRadius: '5px',
    },
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.header}>✅ Payment Successful!</h1>
      <p>Your blog articles have been generated.</p>
      
      {isDownloadReady && zipFilename ? (
        <div>
          <button style={styles.button} onClick={() => handleDownload(zipFilename)}>
            Download Your Articles (.zip)
          </button>
          
          <div style={styles.instructions}>
            <strong>Note for Mobile Users:</strong> On devices like iPhone/iPad, your file will be saved to the **'Files' app**. Please open the 'Files' app and look in your 'Downloads' folder to find and unzip your articles.
          </div>
        </div>
      ) : (
        <p>Verifying your download...</p>
      )}
    </div>
  );
};

export default SuccessPage;